const constants = {
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.mubi',
  playStoreGoUrl: 'https://play.google.com/store/apps/details?id=com.mubi.go',
  appStoreUrl:
    'https://itunes.apple.com/app/apple-store/id626148774?pt=2050088&ct=Modal&mt=8',
  appStoreGoUrl: 'https://itunes.apple.com/app/apple-store/id1406769786',
  castImagePlaceholderUrl:
    'https://assets.mubicdn.net/website/cast_member_placeholder.png',
  languageRoutes: [
    'de',
    'es',
    'fr',
    'it',
    'ms',
    'nl',
    'pt',
    'tr',
  ],
  paidPromoTypes: ['FreeTrial', 'Discount', 'FixedDiscount'],
};
export default constants;
